import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const MMLiteUpToDateErrorSchema = BusinessErrorSchema.extend({
  field: z.enum(['"still_actual"']),
})
